export const AppTypes = Object.freeze({
	CanTrack: 'cantrackv3',
	CanAppsV3: 'canappsv3',
	CanAppsV1: 'canappsv1',
	Regular: 'regular',
});
